import React, { useEffect } from "react";
import { useFormikContext } from "formik";
import styled from "styled-components";

import FormGroup from "../../Common/FormGroup";
import SelectField from "../../Common/AutoComplete";
import PhoneInput from "../../Common/PhoneInput";
import InputField from "../../Common/InputField";
import { usStates } from "../../../../Components/register/constant";
// import { Column } from "../../../../Css";
import { Body, Column, Header, Wrapper } from "../../../../Css";
import ShippingInformationForm from "./ShippingInformationForm";
import ApiService from "../../../Api/ApiServices";
import { useTranslation } from "react-i18next";

function BillingInformationForm({ onPrevious, setInitialValue }) {
  const { getFieldProps, setTouched, values, setFieldValue } = useFormikContext();
  const { t } = useTranslation();
  console.log("values: ", values);

  const getShippingData = async () => {
    try {
      const { data } = await ApiService.getShippingInfo();
      const { data: billingData } = await ApiService.getBillingInfo();
      const billingInfo = billingData?.billingInfo;
      const shippingInfo = data?.shippingInfo;
      setInitialValue({
        ...values,
        firstNameB: billingInfo?.firstName,
        lastNameB: billingInfo?.lastName,
        streetAddB: billingInfo?.address1,
        addressB: billingInfo?.address2,
        CityB: billingInfo?.city,
        stateB: billingInfo?.state,
        zipCodeB: billingInfo?.zipCode,
        billing_phone_number: billingInfo?.phoneNumber,
        
        fName: shippingInfo?.firstName,
        lName: shippingInfo?.lastName,
        address_line_1: shippingInfo?.address1,
        address_line_2: shippingInfo?.address2,
        admin_area_2: shippingInfo?.city,
        admin_area_1: shippingInfo?.state,
        billing_postal_code: shippingInfo?.zipCode,
        shipping_phone_number: shippingInfo?.phoneNumber,
        infoChecked: false,
      });
    } catch (error) {
      console.log("error: ", error);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    getShippingData();
    setTouched({
      firstNameB: false,
      lastNameB: false,
      streetAddB: false,
      CityB: false,
      zipCodeB: false,
      stateB: false,
    });
  }, []);

  return (
    <div className="container" style={{ gridTemplateColumns: "90%" }}>
      <Wrapper style={{ marginBottom: "50px" }}>
        <Header>{t("screens.upgradeMembership.billingInformation")}</Header>

        <Body>
          <Column>
            <FormGroup
              label={`${t("screens.formData.firstName")}`}
              name="firstNameB"
              requiredField
              labelClassName="margin-top"
            >
              <InputField
                type="text"
                name="firstNameB"
                {...getFieldProps("firstNameB")}
              />
            </FormGroup>
          </Column>
          <Column>
            <FormGroup
              label={`${t("screens.formData.lastName")}`}
              name="lastNameB"
              requiredField
              labelClassName="margin-top"
            >
              <InputField
                type="text"
                name="lastNameB"
                {...getFieldProps("lastNameB")}
              />
            </FormGroup>
          </Column>
          <Column>
            <FormGroup
              label={`${t("screens.formData.streetAddress")}`}
              name="streetAddB"
              requiredField
              labelClassName="margin-top"
            >
              <InputField
                type="text"
                name="streetAddB"
                {...getFieldProps("streetAddB")}
              />
            </FormGroup>
          </Column>
          <Column>
            <FormGroup
              label={`${t("screens.formData.address2")}`}
              name="addressB"
              labelClassName="margin-top"
            >
              <InputField
                type="text"
                name="addressB"
                {...getFieldProps("addressB")}
              />
            </FormGroup>
          </Column>
          <Column>
            <FormGroup
              label={`${t("screens.formData.city")}`}
              name="CityB"
              requiredField
              labelClassName="margin-top"
            >
              <InputField
                type="text"
                name="CityB"
                {...getFieldProps("CityB")}
              />
            </FormGroup>
          </Column>
          <Column>
            <FormGroup
              label={`${t("screens.formData.stateProvinceRegion")}`}
              name="stateB"
              labelClassName="margin-top"
            >
              <SelectField
                {...getFieldProps("stateB")}
                name="stateB"
                options={usStates}
                placeholder={`${t("screens.formData.selectState")}`}
              />
            </FormGroup>
          </Column>
          <Column>
            <FormGroup
              label={`${t("screens.formData.zipCode")}`}
              name="zipCodeB"
              requiredField
              labelClassName="margin-top"
            >
              <InputField
                type="number"
                name="zipCodeB"
                {...getFieldProps("zipCodeB")}
              />
            </FormGroup>
          </Column>
          <Column>
            <FormGroup
              label={`${t("screens.formData.phoneNumber")}`}
              name="billing_phone_number"
              requiredField
              labelClassName="margin-top"
            >
              <Country>
                <PhoneInput
                  dialCodeName="phone_code"
                  name="billing_phone_number"
                  onChange={(value, country) => {
                    setFieldValue("billing_phone_code", country?.dialCode);
                  }}
                  value={values?.billing_phone_number}
                />
              </Country>
            </FormGroup>
          </Column>
        </Body>
      </Wrapper>
      <ShippingInformationForm
        onPrevious={onPrevious}
        setInitialValue={setInitialValue}
      />
    </div>
  );
}

export default BillingInformationForm;

const Country = styled.div`
  .react-tel-input .form-control {
    border-radius: 5px;
    border: 1px solid gray;
    height: 41px !important;
    width: 100%;
    background: white !important;
  }

  .react-tel-input .flag-dropdown {
    top: 0;
    bottom: 0;
    padding: 0;
    background-color: transparent !important;
    border: transparent !important;
    border-radius: 3px 0 0 3px;
  }

  input:-internal-autofill-selected {
    background-image: none !important;
    background: rgba(255, 255, 255, 0.2) !important;
    color: fieldtext !important;
  }
`;
